import CheckIcon from './Check'
import QuestionIcon from './Question'
import CertifyIcon from './Certify'
import CancelIcon from './Cancel'
import RadioCheckIcon from './RadioCheck'
import RadioUncheckIcon from './RadioUncheck'


export default {
    CheckIcon,
    QuestionIcon,
    CertifyIcon,
    CancelIcon,
    RadioCheckIcon,
    RadioUncheckIcon
}
